import React from 'react';
import '../template-file-css/document-file-template.css'; 


export const C3_AssessmentAddendum = ({
    itemsRef,
    showErrorFor, 
}) => {

    return (
        <form id='C3_AssessmentAddendum' className='file-pdf-document'>
            <div className='file-template'> 
            <p className='w-750'>
                    <h2>Physical and Mental Health Diagnosis and Treatment Table
                    </h2>
                </p>
                <p className='w-750'>
                    <b>
                        Diagnostic Impressions:
                    </b>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Severity</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbSeverityMild_1" name="rbSeverity_1" className='add-only' value="Mild" /> Mild &nbsp;
                            <input type="radio" id="rbSeverityModerate_1" name="rbSeverity_1" className='add-only' value="Moderate" /> Moderate &nbsp;
                            <input type="radio" id="rbSeveritySevere_1" name="rbSeverity_1" className='add-only' value="Severe" /> Severe &nbsp;
                            <input type="radio" id="rbSeverityIncapacitating_1" name="rbSeverity_1" className='add-only' value="Incapacitating" /> Incapacitating &nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Status</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbStatusUncontrolledRequests_1" name="rbStatus_1" className='add-only' value="UncontrolledRequestsTeam" /> Uncontrolled; requests team assistance &nbsp;
                            <input type="radio" id="rbStatusUncontrolledDeclines_1" name="rbStatus_1" className='add-only' value="UncontrolledDeclines" /> Uncontrolled; declines team assistance &nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbStatusControlledTeamAssistance_1" name="rbStatus_1" className='add-only' value="ControlledTeamAssistance" /> Controlled; team assistance still needed &nbsp;
                            <input type="radio" id="rbStatusControlledResolved_1" name="rbStatus_1" className='add-only' value="ControlledResolved" /> Controlled or Resolved; No assistance needed &nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If Member declined team assistance, why?:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtMemberDeclinedTeamAssistance" name="txtMemberDeclinedTeamAssistance" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Past Treatment::</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtPastTreatment" name="txtPastTreatment" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Is the member prescribed medications to assist in managing diagnosis/symptom?:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type="checkbox" id="cbNo" name="cbNo" className='add-only' value="No" />No?
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Why Not?:</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtWhyNot" name="txtWhyNot" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'> Is the member prescribed any form of treatment/services to address diagnosis/symptom?:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbMemberPrescribedAnyFormTreatmentServicesNo" name="rbMemberPrescribedAnyFormTreatmentServices" className='add-only' value="No" /> No In the box below, provide narrative about why not and move to next section
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbMemberPrescribedAnyFormTreatmentServicesYes" name="rbMemberPrescribedAnyFormTreatmentServices" className='add-only' value="Yes" /> Yes In the box below, provide a narrative about type, duration, frequency, last visit dates, etc.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Who are the providers of the services? Include names and organizations:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="text" id="txtProvidersServiceIncludeNameOrganizations" name="txtProvidersServiceIncludeNameOrganizations" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Are they adherent to and engaged in treatment or services related to their diagnosis or symptom?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbAdherentEngagedTreatmentServicesRelatedTheirNo" name="rbAdherentEngagedTreatmentServicesRelatedTheir" className='add-only' value="Yes" /> Yes In the box below provide a narrative about satisfaction of services and what they do and don't like
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbAdherentEngagedTreatmentServicesRelatedTheirYes" name="rbAdherentEngagedTreatmentServicesRelatedTheir" className='add-only' value="No" /> No In the box below provide a narrative about why not and identify any barriers to care
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="radio" id="rbAdherentEngagedTreatmentServicesRelatedTheirDoesNot" name="rbAdherentEngagedTreatmentServicesRelatedTheir" className='add-only' value="DoesNot" /> Does not agree to treatment/ services In the box below, provide a narrative about why not
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            Answer::
                        </td>
                    </tr>
                    <tr>
                    <td className='w-750'>
                            <input type="text" id="txtAnswer" name="txtAnswer" className='add-only' />
                        </td>
                       </tr>
                </table>


            </div>
        </form>

    )
}











